
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("kk78e", function(module, exports) {
$parcel$export(module.exports, "ShareButtonAsync", () => $f192d59a229af669$export$3585ee2128ae4c25);
$parcel$export(module.exports, "default", () => $f192d59a229af669$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $Ay1uj = parcelRequire("Ay1uj");

var $iePme = parcelRequire("iePme");

var $kJsb4 = parcelRequire("kJsb4");

var $7ep4S = parcelRequire("7ep4S");

var $8IeH1 = parcelRequire("8IeH1");

var $lRq8t = parcelRequire("lRq8t");

var $lppZM = parcelRequire("lppZM");
var $KzPeJ = parcelRequire("KzPeJ");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $1qbKn = parcelRequire("1qbKn");

var $lQyw6 = parcelRequire("lQyw6");

var $ckXxu = parcelRequire("ckXxu");

var $ekX5h = parcelRequire("ekX5h");
const $f192d59a229af669$var$styles = {
    spinnerContainer: "_y3gn1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $f192d59a229af669$var$LoadingIndicator = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $f192d59a229af669$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "small"
    }));
const $f192d59a229af669$var$TriggerRenderer = ({ isDisabled: isDisabled = false, isLoading: isLoading = false, triggerRef: triggerRef, renderCustomTriggerButton: renderCustomTriggerButton, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const fakeRef = (0, $eJOHy.useRef)(null);
    return renderCustomTriggerButton ? renderCustomTriggerButton({
        isDisabled: isDisabled,
        isSelected: isLoading,
        onClick: onClick
    }, {
        ref: triggerRef ?? fakeRef,
        'aria-expanded': false,
        'aria-haspopup': false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ), {
        ref: triggerRef ?? fakeRef,
        testId: "share-button.button",
        label: formatMessage((0, $lQyw6.messages).shareTriggerButtonText),
        appearance: "default",
        isDisabled: isDisabled,
        isLoading: isLoading,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iePme))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon, #44546F)"
            }),
        onClick: onClick
    });
};
const $f192d59a229af669$export$3585ee2128ae4c25 = ({ errorBoundaryId: errorBoundaryId, teamName: teamName, ...props })=>{
    const { renderCustomTriggerButton: renderCustomTriggerButton } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { Panel: Panel, trigger: trigger } = (0, $KzPeJ.usePanel)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({}), []);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            ...props
        }), [
        props
    ]);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    if ((0, $4cTDP.fg)('empanada_nin_covnert_share_to_entrypoint')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: errorBoundaryId,
        packageName: "jiraShareButton",
        teamName: teamName,
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f192d59a229af669$var$TriggerRenderer, {
                renderCustomTriggerButton: renderCustomTriggerButton,
                isDisabled: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
                id: errorBoundaryId,
                error: error
            }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ekX5h.EntrypointPropsProvider), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: trigger,
        entryPoint: (0, $ckXxu.shareButtonEntryPoint),
        entryPointParams: entryPointParams,
        errorFallback: ({ error: error })=>{
            // Throw error back up the stack to be caught and logged by the JSErrorBoundary
            throw error;
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
            content: $f192d59a229af669$var$LoadingIndicator,
            isOpen: true,
            placement: props.dialogPlacement ?? 'left-start',
            trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f192d59a229af669$var$TriggerRenderer, {
                    renderCustomTriggerButton: renderCustomTriggerButton,
                    isLoading: true,
                    triggerRef: ref
                })
        })
    }, ({ ref: ref })=>!isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f192d59a229af669$var$TriggerRenderer, {
            triggerRef: ref,
            renderCustomTriggerButton: renderCustomTriggerButton,
            onClick: ()=>setIsOpen(true)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Panel, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: errorBoundaryId,
        packageName: "jiraShareButton",
        teamName: teamName,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: trigger,
        entryPoint: (0, $ckXxu.shareButtonEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps
    }, ({ ref: ref })=>!isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ), {
            ref: ref,
            testId: "share-button.button",
            label: formatMessage((0, $lQyw6.messages).shareTriggerButtonText),
            appearance: "default",
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iePme))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
            onClick: ()=>setIsOpen(true)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Panel, null));
};
var $f192d59a229af669$export$2e2bcd8739ae039 = $f192d59a229af669$export$3585ee2128ae4c25;

});
parcelRegister("iePme", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0eee459540e5ec28215a3b80df0172>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4715f5959b077cc$var$_react = $d4715f5959b077cc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d4715f5959b077cc$var$_baseNew = $d4715f5959b077cc$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d4715f5959b077cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4715f5959b077cc$var$ShareIcon = (props)=>/*#__PURE__*/ $d4715f5959b077cc$var$_react.default.createElement($d4715f5959b077cc$var$_baseNew.default, Object.assign({
        name: "ShareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$d4715f5959b077cc$var$ShareIcon.displayName = 'ShareIcon';
var $d4715f5959b077cc$var$_default = module.exports.default = $d4715f5959b077cc$var$ShareIcon;

});

parcelRegister("lQyw6", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e033b89304d7d864$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e033b89304d7d864$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("ckXxu", function(module, exports) {
$parcel$export(module.exports, "shareButtonEntryPoint", () => $7048a914842a377c$export$ad8b1559c594245d);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7048a914842a377c$export$ad8b1559c594245d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("dwydV")), {
        moduleId: "50ae946e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dwydV", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kBKb2")
]).then(()=>parcelRequire('9c4AY'));

});


parcelRegister("ekX5h", function(module, exports) {
$parcel$export(module.exports, "EntrypointPropsContext", () => $cca424618461430d$export$4c4cf33df5e3a573);
$parcel$export(module.exports, "EntrypointPropsProvider", () => $cca424618461430d$export$11fb94117e9f43f7);

var $eJOHy = parcelRequire("eJOHy");
const $cca424618461430d$var$initialProps = {
    integrationType: '',
    productId: 'jira',
    subProductId: 'jira-platform',
    shareTitle: '',
    shareContentType: '',
    objectAri: ''
};
const $cca424618461430d$export$4c4cf33df5e3a573 = /*#__PURE__*/ (0, $eJOHy.createContext)($cca424618461430d$var$initialProps);
const $cca424618461430d$export$11fb94117e9f43f7 = ({ isAutoOpenDialog: isAutoOpenDialog, shouldAutoDismissFlag: shouldAutoDismissFlag, integrationType: integrationType, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, renderCustomTriggerButton: renderCustomTriggerButton, customTriggerButtonIcon: customTriggerButtonIcon, testId: testId, productId: productId, subProductId: subProductId, shareLink: shareLink, shareTitle: shareTitle, shareContentType: shareContentType, shareFormTitle: shareFormTitle, objectAri: objectAri, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, integrationMode: integrationMode, legacyShareClientConfig: legacyShareClientConfig, copyTooltipText: copyTooltipText, shareShortcutTriggerCount: shareShortcutTriggerCount, prevShareShortcutTriggerCount: prevShareShortcutTriggerCount, onDialogClose: onDialogClose, onTriggerButtonClick: onTriggerButtonClick, shareFormHelperMessage: shareFormHelperMessage, shareFieldsFooter: shareFieldsFooter, poSpotlightShareButtonId: poSpotlightShareButtonId, customHeader: customHeader, onSubmit: onSubmit, children: children })=>{
    const value = (0, $eJOHy.useMemo)(()=>({
            isAutoOpenDialog: isAutoOpenDialog,
            shouldAutoDismissFlag: shouldAutoDismissFlag,
            integrationType: integrationType,
            triggerButtonAppearance: triggerButtonAppearance,
            triggerButtonStyle: triggerButtonStyle,
            renderCustomTriggerButton: renderCustomTriggerButton,
            customTriggerButtonIcon: customTriggerButtonIcon,
            testId: testId,
            productId: productId,
            subProductId: subProductId,
            shareLink: shareLink,
            shareTitle: shareTitle,
            shareContentType: shareContentType,
            shareFormTitle: shareFormTitle,
            objectAri: objectAri,
            shareIntegrations: shareIntegrations,
            additionalTabs: additionalTabs,
            builtInTabContentWidth: builtInTabContentWidth,
            integrationMode: integrationMode,
            legacyShareClientConfig: legacyShareClientConfig,
            copyTooltipText: copyTooltipText,
            shareShortcutTriggerCount: shareShortcutTriggerCount,
            prevShareShortcutTriggerCount: prevShareShortcutTriggerCount,
            onDialogClose: onDialogClose,
            onTriggerButtonClick: onTriggerButtonClick,
            shareFormHelperMessage: shareFormHelperMessage,
            shareFieldsFooter: shareFieldsFooter,
            poSpotlightShareButtonId: poSpotlightShareButtonId,
            customHeader: customHeader,
            onSubmit: onSubmit
        }), [
        isAutoOpenDialog,
        shouldAutoDismissFlag,
        integrationType,
        triggerButtonAppearance,
        triggerButtonStyle,
        renderCustomTriggerButton,
        customTriggerButtonIcon,
        testId,
        productId,
        subProductId,
        shareLink,
        shareTitle,
        shareContentType,
        shareFormTitle,
        objectAri,
        shareIntegrations,
        additionalTabs,
        builtInTabContentWidth,
        integrationMode,
        legacyShareClientConfig,
        copyTooltipText,
        shareShortcutTriggerCount,
        prevShareShortcutTriggerCount,
        onDialogClose,
        onTriggerButtonClick,
        shareFormHelperMessage,
        shareFieldsFooter,
        poSpotlightShareButtonId,
        customHeader,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cca424618461430d$export$4c4cf33df5e3a573.Provider, {
        value: value
    }, children);
};

});



$parcel$global.rlb("c8zR3")
//# sourceMappingURL=share-button.19a795d9.js.map
